import * as React from "react";

import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import { days } from "../../types";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
  autoFocus: false,
};

export interface PublicationDaysSelectProps {
  selectedDays: string[];
  onChange?: (newDays: string[]) => void;
  disabledDays?: string[];
}

export const PublicationDaysSelect: React.FC<PublicationDaysSelectProps> = ({
  selectedDays,
  onChange,
  disabledDays = [],
}) => {
  return (
    <FormControl sx={{ m: 1, width: "100%" }}>
      <Select
        displayEmpty
        multiple
        MenuProps={MenuProps}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return "Välj utgivningsdagar";
          }
          const allWeekdays = [
            "monday",
            "tuesday",
            "wednesday",
            "thursday",
            "friday",
            "saturday",
            "sunday",
          ];
          const filteredSelected = selected.filter(Boolean);

          if (
            filteredSelected.length === allWeekdays.length &&
            allWeekdays.every((day) => filteredSelected.includes(day))
          ) {
            return "Alla dagar";
          }

          return filteredSelected
            .map((key) => days[key as keyof typeof days])
            .join(", ");
        }}
        size="small"
        sx={{ bgcolor: "background.paper", maxWidth: "10rem" }}
        value={selectedDays}
        onChange={(event: SelectChangeEvent<string[]>) => {
          if (onChange) {
            onChange(event.target.value as string[]);
          }
        }}
      >
        {Object.entries(days).map(([key, name]) => {
          const isDisabled =
            disabledDays.includes(key) && !selectedDays.includes(key);
          return (
            <MenuItem
              key={key}
              disabled={isDisabled}
              sx={isDisabled ? { opacity: 0.5 } : undefined}
              value={key}
            >
              <Checkbox checked={selectedDays.includes(key)} />
              <ListItemText primary={name} />
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default PublicationDaysSelect;
